import { render, staticRenderFns } from "./orderAudit.vue?vue&type=template&id=524ecfc5&scoped=true"
import script from "./orderAudit.vue?vue&type=script&lang=js"
export * from "./orderAudit.vue?vue&type=script&lang=js"
import style0 from "./orderAudit.vue?vue&type=style&index=0&id=524ecfc5&prod&lang=scss"
import style1 from "./orderAudit.vue?vue&type=style&index=1&id=524ecfc5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524ecfc5",
  null
  
)

export default component.exports